import React, {Component} from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import {Accordion, Dimmer, Header, Icon, List, Loader, Message, Segment, Table} from 'semantic-ui-react';

let objectKeysCapitalize = function (input) {
    if (typeof input !== 'object') return input;
    if (Array.isArray(input)) return input.map(objectKeysCapitalize);
    return Object.keys(input).reduce(function (newObj, key) {
        let val = input[key];
        newObj[key.charAt(0).toUpperCase() + key.slice(1)] = (val !== 'undefined' && val !== null && typeof val === 'object') ? objectKeysCapitalize(val) : val;
        return newObj;
    }, {});
};

export default class Accounts extends Component {

    state = {accounts: [], total: 0, cashTotal: 0, activeIndex: 0, loading: true, error: false};

    handleClick = (e, titleProps) => {
        const { index } =  titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex });
    };

    componentDidMount() {
        axiosRetry(axios, { retries: 3});
        axiosRetry(axios, { retryDelay: (retryCount) => {
            console.log("retrying...");
            return retryCount * 4000;
        }});

        axios.get('/api/accountdetails/' + this.props.env).then(response => {
            let total = 0;
            let cashTotal = 0;
            let finalData = [];
            if (response !== null && response.data !== null) {
                for (let [fi, accounts] of Object.entries(response.data)) {
                    if (accounts !== null && accounts !== 'undefined') {
                        let payload = objectKeysCapitalize(accounts);
                        let data = payload.Accounts;

                        for (const [key, value] of Object.entries(data)) {
                            console.log(key);
                            if (Array.isArray(value)) {
                                for (const account of value) {
                                    total += account.CurrentValue ? account.CurrentValue : 0;
                                    cashTotal += account.AvailableCashBalance ? account.AvailableCashBalance : 0;
                                    account.FI = fi;
                                    if (account.Holdings == null || account.Holdings === 'undefined') {
                                        account.Holdings = [];
                                    }
                                    if (account.Transactions == null || account.Transactions === 'undefined') {
                                        account.Transactions = [];
                                    }
                                    finalData.push(account);
                                }
                            }
                        }
                    }
                }
            }
            this.setState({accounts: finalData, error: finalData.length === 0, total: total, cashTotal: cashTotal, loading: false});
        }).catch(err => {
            console.log(err);
            this.setState({error: true, loading: false});
        });
    }

    render() {

        const {accounts, total, cashTotal, activeIndex, loading, error} = this.state;

        return (
            <Segment.Group className='hooli-segment'>
                <Dimmer inverted active={loading} className='hooli-segment'>
                    <Loader inverted size='medium' content='Loading Accounts' />
                </Dimmer>
                <Segment className='hooli-segment-top'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>
                                <a href='/account-select'><Icon name='add' className='hooli-btn-segment' /> Add an account</a>
                            </List.Content>
                            <List.Header><h3 className='hooli-text-dark-blue'>ACCOUNTS</h3></List.Header>
                        </List.Item>
                    </List>
                </Segment>
                {error ?
                    (<Segment>
                        <Message error>
                            <p>There was an issue while retrieving your accounts.</p>
                            <p>Please try refreshing or check back later.</p>
                        </Message>
                    </Segment>)
                    : accounts.map(account => (
                    <Segment key={account.AccountId} className='hooli-background-lightgrey'>
                        <Accordion as={List} vertical>
                            <List.Item>
                                <Accordion.Title
                                    active={activeIndex === account.AccountId}
                                    index={account.AccountId}
                                    onClick={this.handleClick}
                                    content={<div>
                                        <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>{account.FI}</div>
                                        <List.Content floated='right'>
                                            ${account.CurrentValue ? account.CurrentValue.toLocaleString(navigator.language, {minimumFractionDigits: 2}) : 0.00}
                                            {activeIndex === account.AccountId ?
                                                <Icon className='hooli-text-blue' name='angle up'/>
                                                : <Icon className='hooli-text-blue' name='angle down'/>}
                                        </List.Content>
                                        <List.Header>{account.Nickname || account.DisplayName}</List.Header>
                                        <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>{account.AccountNumber}</div>
                                        <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>
                                            Available Cash: ${account.AvailableCashBalance ? account.AvailableCashBalance.toLocaleString(navigator.language, {minimumFractionDigits: 2}) : 0.00}
                                        </div>
                                    </div>}
                                />
                                <Accordion.Content
                                    active={activeIndex === account.AccountId}
                                    content={
                                        <div>
                                            <h4 className='hooli-text-dark-blue'>HOLDINGS</h4>
                                            {account.Holdings.length > 0 ?
                                                <Table celled unstackable>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>SYMBOL</Table.HeaderCell>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>MARKET VALUE</Table.HeaderCell>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>QUANTITY</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>

                                                    <Table.Body>
                                                        {account.Holdings.map(holding => (
                                                            <Table.Row key={holding.FiAttributes && holding.FiAttributes.length !== 0 && holding.FiAttributes.find(a => a.Name === "SecurityId")
                                                                ? holding.FiAttributes.find(a => a.Name === "SecurityId").Value : holding.Symbol}
                                                                       className='hooli-background-lightgrey'>
                                                                <Table.Cell>{holding.Symbol}</Table.Cell>
                                                                <Table.Cell>{holding.MarketValue}</Table.Cell>
                                                                <Table.Cell>{holding.Units}</Table.Cell>
                                                            </Table.Row>
                                                        ))}
                                                    </Table.Body>
                                                </Table>
                                                :
                                                <Message warning>
                                                    <p>There is no recent holding information for this account.</p>
                                                </Message>
                                            }
                                            <h4 className='hooli-text-dark-blue'>TRANSACTIONS</h4>
                                            {account.Transactions.length > 0 ?
                                                <Table celled unstackable>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>TIME</Table.HeaderCell>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>DESCRIPTION</Table.HeaderCell>
                                                            <Table.HeaderCell className='hooli-nav-blue hooli-text-white'>AMOUNT</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>

                                                    <Table.Body>
                                                        {account.Transactions.map(txn => (
                                                            <Table.Row key={txn.TransactionId} className='hooli-background-lightgrey'>
                                                                <Table.Cell>{(new Date(txn.TransactionTimestamp * 1000)).toDateString()}</Table.Cell>
                                                                <Table.Cell>{txn.Description}</Table.Cell>
                                                                <Table.Cell>
                                                                    {txn.Amount < 0 ?
                                                                        <Header as='h4' color='red'>
                                                                            {"(" + txn.Amount.toString().replace('-', '') + ")"}
                                                                        </Header>
                                                                        :
                                                                        <Header as='h4' color='green'>
                                                                            {txn.Amount}
                                                                        </Header>
                                                                    }
                                                                </Table.Cell>
                                                                {/*<Table.Cell>{txn.Amount < 0 ? "(" + txn.Amount.toString().replace('-', '') + ")" : txn.Amount}</Table.Cell>*/}
                                                            </Table.Row>
                                                        ))}
                                                    </Table.Body>
                                                </Table>
                                                :
                                                <Message warning>
                                                    <p>There is no recent transaction information for this account.</p>
                                                </Message>
                                            }
                                        </div>
                                    }
                                />
                            </List.Item>
                        </Accordion>
                    </Segment>
                ))}
                <Segment className='hooli-segment-bottom'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>${total ? total.toLocaleString(navigator.language, {minimumFractionDigits: 2}) : 0.00}</List.Content>
                            <List.Header>Total</List.Header>
                            <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>Total Available Cash: ${cashTotal ? cashTotal.toLocaleString(navigator.language, {minimumFractionDigits: 2}) : 0.00}</div>
                        </List.Item>
                    </List>
                </Segment>
            </Segment.Group>
        )

    }

}
